module.exports = __webpack_public_path__ + "img/5191984.3ac42802.jpg";